// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";

function getFormatConsumption(consumptionSymbols) {
  let symbolMap = Stdlib_Nullable.getOr(consumptionSymbols, {
    "300": "I",
    "500": "X"
  });
  return consumptionMilliliters => {
    if (consumptionMilliliters < 400) {
      return symbolMap[300];
    } else {
      return symbolMap[500];
    }
  };
}

let smallBeerInMilliliters = 300;

let largeBeerInMilliliters = 500;

export {
  smallBeerInMilliliters,
  largeBeerInMilliliters,
  getFormatConsumption,
}
/* No side effect */
